import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WsDatePicker, BellIcon, WsSelect, WsSelectObj } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

export interface WsFilterPropsWithSubmitUpdate extends WsFilterProps {
  isSubmittedOrUpdated?: boolean;
  selectStatus?: string;
  selectArray?: WsSelectObj[];
}

const DateFilterStatusOptions = [
  {
    label: 'Submitted Between',
    value: 'CREATED_BETWEEN',
  },
  {
    label: 'Updated Between',
    value: 'UPDATED_BETWEEN',
  },
  {
    label: 'Submitted Or Updated Between',
    value: 'CREATED_OR_UPDATED_BETWEEN',
  },
];

const CreatedBwDatesFilter = ({
  name,
  name1,
  selectStatus,
  title,
  selectArray = DateFilterStatusOptions,
  disableFuture = true,
  showAccordionIcon,
  isSubmittedOrUpdated = false,
}: WsFilterPropsWithSubmitUpdate) => {
  const { watch } = useFormContext();

  return (
    <WsAccordion
      title={title ?? 'Created Between'}
      {...(showAccordionIcon && { startIcon: <BellIcon /> })}
    >
      <Stack mx={2} spacing={1}>
        {isSubmittedOrUpdated && (
          <WsSelect
            name={selectStatus ?? 'SubmittedOrUpdatedbetween'}
            label="Filter By"
            selectArray={selectArray}
            defaultValue=""
          />
        )}
        <WsDatePicker name={name} label="From Date" disableFuture={disableFuture} />
        <WsDatePicker
          name={name1 ?? ''}
          label="To Date"
          minDate={watch(name)}
          disableFuture={disableFuture}
        />
      </Stack>
    </WsAccordion>
  );
};
export default CreatedBwDatesFilter;
